<div class="page">
  <div class="d-flex flex-wrap align-items-center">
    <div class="d-flex flex-wrap align-items-center ml-auto gap">
      <div class="header-btn" *ngIf="order?.saleMethodBranch?.HasDelino">
        {{ "ClientApp.FrontOffice.Order.OrderOnline.Delino" | translate }}
      </div>
      <div class="header-btn" (click)="activeModel = true" [class.active]="activeModel" *ngIf="order?.saleMethodBranch?.ApplySnap">
        {{ "ClientApp.FrontOffice.Order.OrderOnline.Snap" | translate }}
      </div>
    </div>
    <div class="d-flex flex-wrap align-items-center gap">
      <div class="header-btn" name="SuccessOrder" (click)="showSuccessOrder()">
        {{ "ClientApp.FrontOffice.Order.OrderOnline.SuccessOrder" | translate }}
      </div>
      <div class="header-btn" name="SuccessOrder" (click)="getLinkAddress()">
        {{ "ClientApp.FrontOffice.Order.OrderOnline.AddressLinkFactor" | translate }}
      </div>
      <div class="header-btn" name="CancelOrder" (click)="ShowCauseCancel()">
        {{ "ClientApp.FrontOffice.Order.OrderOnline.CauseCancel.CauseCancel" | translate }}
      </div>
      <div class="header-btn" name="CallSupport" (click)="showSupport()">
        {{ "ClientApp.FrontOffice.Order.OrderOnline.CallSupport.CallSupport" | translate }}
      </div>
    </div>
  </div>

  <div class="grid-wrapper">
    <div class="statebox">
      <ssg-select
        *ngIf="order.isMultiBranch && order.currentSaleMethodNature === order.SaleMethodNature.Delivery"
        name="branchFilter"
        [multiple]="true"
        [group]="formGroup"
        userClass="select-sm"
        dropdownPosition="auto"
        limitSelection="5"
        [hasSelectAll]="true"
        [label]="'General.Branch' | translate"
        (valueChange)="onBranchFilterChanged($event)"
        (valueClear)="onBranchFilterClear()"
        [dataList]="allBranchesExceptCallCenter"
        textFieldName="Title"
        valueFieldName="Id">
      </ssg-select>
      <date-picker
        id="dateTimeFactorFilter"
        name="dateTimeFactorFilter"
        [group]="formGroup"
        [label]="'ClientApp.FrontOffice.Order.OrderOnline.Date' | translate"
        userClass="select-sm"
        required="false"
        textType="date"
        disabled="false"
        (valueChange)="applyDateFilter($event)">
      </date-picker>
      <ssg-select
        name="invoiceFilter"
        [group]="formGroup"
        userClass="select-sm"
        dropdownPosition="auto"
        [label]="'ClientApp.FrontOffice.Order.OrderOnline.InvoiceStatus' | translate"
        (valueChange)="setFilter($event)"
        [dataList]="invoiceFilter"
        textFieldName="title"
        valueFieldName="key">
      </ssg-select>
    </div>
    <div class="header" *ngIf="onFilter && apiName != undefined">
      <kgrid
        #factorList
        *ngIf="columns && columns.length > 0"
        [apiName]="apiName"
        [name]="apiName"
        [columns]="columns"
        [areaName]="areaName"
        [isEdit]="false"
        [isDelete]="false"
        [isAdd]="false"
        (onRowSelected)="onRowsSelected($event)"
        [isModal]="false"
        [filters]="onFilter"
        defaultSortKey="ClientFactorStateID,CreatedDate"
        defaultSortKeyKind="asc"
        [noAutoFitColumns]="true"
        [groupable]="false">
      </kgrid>
    </div>
    <div class="detail">
      <kgrid
        [name]="apiName"
        [columns]="orderItemsColumns"
        [areaName]="areaName"
        [isEdit]="false"
        [isDelete]="false"
        [dataList]="dataList"
        [isAdd]="false"
        [isModal]="false"
        [hideToolber]="true"
        [noToolBar]="true"
        [noAutoFitColumns]="true"
        [groupable]="false">
      </kgrid>
    </div>
  </div>
</div>
